export const EXPAND_ALL = 'Expand All';
export const COLLAPSE_ALL = 'Collapse All';

export const defaultFilterElement = { colId: undefined, isCaseSensitive: false, isChecked: false };
